function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.9925 0.5C3.8525 0.5 0.5 3.86 0.5 8C0.5 12.14 3.8525 15.5 7.9925 15.5C12.14 15.5 15.5 12.14 15.5 8C15.5 3.86 12.14 0.5 7.9925 0.5ZM13.6025 5.87L9.845 5.5475L8.345 2.015C10.7525 2.1575 12.7775 3.7175 13.6025 5.87ZM8 9.485L9.8 10.565L9.32 8.5175L10.9025 7.145L8.8175 6.965L8 5.045L7.1825 6.9725L5.0975 7.1525L6.68 8.525L6.2075 10.565L8 9.485ZM7.655 2.015L6.155 5.555L2.39 5.8775C3.215 3.7175 5.24 2.15 7.655 2.015ZM2.1725 6.605C2.06 7.055 2 7.52 2 8C2 9.86 2.8475 11.525 4.1825 12.6275L5.015 9.065L2.1725 6.605ZM4.88 13.115L8 11.2325L11.12 13.1075C10.205 13.67 9.14 14 7.9925 14C6.8525 14 5.7875 13.67 4.88 13.115ZM10.985 9.065L11.8175 12.6275C13.145 11.525 14 9.86 14 8C14 7.52 13.9325 7.0475 13.8275 6.605L10.985 9.065Z",
  fill: "#F2C94C"
});

var SvgHighest = function SvgHighest(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHighest, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/highest.ec22cfbd.svg";
export { ForwardRef as ReactComponent };